import { render, staticRenderFns } from "./PopularArtists.vue?vue&type=template&id=f2236f22&scoped=true"
import script from "./PopularArtists.vue?vue&type=script&lang=js"
export * from "./PopularArtists.vue?vue&type=script&lang=js"
import style0 from "./PopularArtists.vue?vue&type=style&index=0&id=f2236f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2236f22",
  null
  
)

export default component.exports